<template>
  <div id="form-slideshow-add">
    <div class="vs-editor-canvas">
      <template>
        <Draggable v-for="(each) of items.slice().reverse()" :key="each.id" :item="each" :ratio="ratio"/>
      </template>
    </div>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>
<script>

import Draggable from "./Draggable";
import BaseFormLoading from "./base/BaseFormLoading";
import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";

export default {
  name: 'Player',
  components: {Draggable, BaseFormLoading},
  data: function () {
    return {
      loading: {value: false},
      items: [],
      ratio: null
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadPreview();
  },
  methods: {
    loadPreview() {
      let that = this;
      if (this.$route.query && this.$route.query['id'] && this.$route.query['code'] && this.$route.query['k']) {
        this.loading.value = true;
        var code = decodeURIComponent(this.$route.query['code']);
        var keyAes = decodeURIComponent(this.$route.query['k']);
        var decryptToken = AES.decrypt(code, atob(keyAes)).toString(enc);
        this.$helper.loadDataSource({
          url: "/slide_show_preview/findById",
          options: {
            accessToken: decryptToken
          },
          dataSubmit: function () {
            return {
              id: that.$route.query['id']
            };
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.$router.push("/errors/400")
            } else {
              let value = response.data.data;
              var widthScreen = $(window).width();
              var heightScreen = $(window).height();
              var widthRatio = value.widthDesign / widthScreen;
              var heightRatio = value.heightDesign / heightScreen;
              if (value != null && (value.draggableModels != null && value.draggableModels.length > 0)) {
                value.draggableModels.map(each => {
                  var calculateTransform = {
                    width: each.transform.width / widthRatio,
                    height: each.transform.height / heightRatio,
                    x: each.transform.x / widthRatio,
                    y: each.transform.y / heightRatio,
                    rotation: each.transform.rotation
                  }
                  each.transform = calculateTransform;
                })
                that.loading.value = false;
                that.items = value.draggableModels;
                that.ratio = value.ratio;
              }
            }
          },
          errorCallback: function (error) {
            that.loading.value = false;
            that.$helper.handleError(that.$router, error);
          },
        });
      } else {
        this.$router.push("/errors/404")
      }
    }
  },
  watch: {},
  destroyed() {
  }
}
</script>

<style scoped>
/*video {*/
/*  object-fit: cover;*/
/*}*/
</style>
<style>
body {
  pointer-events: none;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Preview.vue